
import { BaseBackgroundEffectType } from '@/types';
import { BackgroundRegistry } from './BackgroundRegistry';
import { SolidBackground } from './effects/SolidBackground';
import { LinearGradientBackground } from './effects/LinearGradientBackground';
import { MeshGradientBackground } from './effects/MeshGradientBackground';
import { PlasmaBackground } from './effects/PlasmaBackground';
import { RadialGradientBackground } from './effects/RadialGradientBackground';
import { StarfieldBackground } from './effects/StarfieldBackground';
import { ScanlineBackground } from './effects/ScanlineBackground';
import { AuroraBaseBackground } from './effects/AuroraBaseBackground';
import { MatrixCodeBackground } from './effects/MatrixCodeBackground';
import { DeepSpaceBackdrop } from './effects/DeepSpaceBackdrop';

export const initializeBackgroundRegistry = () => {
    BackgroundRegistry.register(BaseBackgroundEffectType.SOLID, new SolidBackground());
    BackgroundRegistry.register(BaseBackgroundEffectType.LINEAR_GRADIENT, new LinearGradientBackground());
    BackgroundRegistry.register(BaseBackgroundEffectType.RADIAL_GRADIENT, new RadialGradientBackground());
    BackgroundRegistry.register(BaseBackgroundEffectType.MESH_GRADIENT, new MeshGradientBackground());
    BackgroundRegistry.register(BaseBackgroundEffectType.PLASMA, new PlasmaBackground());
    BackgroundRegistry.register(BaseBackgroundEffectType.STARFIELD, new StarfieldBackground());
    BackgroundRegistry.register(BaseBackgroundEffectType.SCANLINE, new ScanlineBackground());
    BackgroundRegistry.register(BaseBackgroundEffectType.AURORA_BASE, new AuroraBaseBackground());
    BackgroundRegistry.register(BaseBackgroundEffectType.MATRIX_CODE, new MatrixCodeBackground());
    BackgroundRegistry.register(BaseBackgroundEffectType.DEEP_SPACE, new DeepSpaceBackdrop());
    // New Effects
    BackgroundRegistry.register(BaseBackgroundEffectType.RGB_WAVE, new PlasmaBackground());
    BackgroundRegistry.register(BaseBackgroundEffectType.CYBER_GRID, new ScanlineBackground());
    BackgroundRegistry.register(BaseBackgroundEffectType.KALEIDOSCOPE, new MeshGradientBackground());
    // Fallbacks
    BackgroundRegistry.register(BaseBackgroundEffectType.VIGNETTE, new SolidBackground());
    BackgroundRegistry.register(BaseBackgroundEffectType.NOISE_GRAIN, new SolidBackground());
    BackgroundRegistry.register(BaseBackgroundEffectType.GEOMETRIC_TILES, new LinearGradientBackground());
    BackgroundRegistry.register(BaseBackgroundEffectType.STATIC_IMAGE, new SolidBackground());
    BackgroundRegistry.register(BaseBackgroundEffectType.IMAGE_BACKDROP, new SolidBackground());
    BackgroundRegistry.register(BaseBackgroundEffectType.VIDEO_STREAM, new SolidBackground());
};
